import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildCandlestickTileConfigSlice } from 'widgets/candlestickTile/store/config/configslice';
import { CandlestickTileState } from 'widgets/candlestickTile/store/CandlestickTileState';
import { CandlestickTileActionPayload } from 'widgets/candlestickTile/store/actions';

const { reducer: configReducer } = buildCandlestickTileConfigSlice();

const candlestickTileWidgetReducer = combineReducers<CandlestickTileState>({
    config: configReducer,
});

export const candlestickTileWidgetsReducer = createWidgetsReducer<
    CandlestickTileState,
    CandlestickTileActionPayload
>(WidgetType.CANDLESTICK_TILE, candlestickTileWidgetReducer);
